import React, { useEffect } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { Link } from 'react-router-dom';
function Club() {
  useEffect(() => {
    document.title = 'Club-  CARMEL CONVENT SCHOOL, DHARUHERA';
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Club</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">Club</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <p>The School offers various clubs for the students.  The club activities provide ample opportunities to the students to engage themselves in a wide variety of co-curricular activities.</p>
              <ul className="mainlist">
                <li>    Science & Eco Club </li>
                <li>    Peace & Kindness Club </li>
                <li>    Health & Wellness Club </li>
                <li>    Heritage Club </li>
                <li>    Literary Club </li>
              </ul>
            </div>
          </div>

          <div className='py-2'></div>
          <div className="row g-4 Club-gallery">
            <h5>Science & Eco Club </h5>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-1.jpeg" alt="Science & Eco Club" />
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-2.jpeg" alt="Science & Eco Club" />
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-3.jpeg" alt="Science & Eco Club" />
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-4.jpeg" alt="Science & Eco Club" />
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-5.jpeg" alt="Science & Eco Club" />
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-6.jpeg" alt="Science & Eco Club" />
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-7.jpeg" alt="Science & Eco Club" />
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-8.jpeg" alt="Science & Eco Club" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-9.jpeg" alt="Science & Eco Club" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-10.jpeg" alt="Science & Eco Club" />
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-11.jpeg" alt="Science & Eco Club" />
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-12.jpeg" alt="Science & Eco Club" />
              </div>
            </div>
          </div>

          <div className='py-2'></div>
          <div className="row g-4 Club-gallery">
            <h5>Heritage Club </h5>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-1.jpeg" alt="Heritage Club 1" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-2.jpeg" alt="Heritage Club 2" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-3.jpeg" alt="Heritage Club 3" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-4.jpeg" alt="Heritage Club 4" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-5.jpeg" alt="Heritage Club 5" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-6.jpeg" alt="Heritage Club 6" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-7.jpeg" alt="Heritage Club 7" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-8.jpeg" alt="Heritage Club 8" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-9.jpeg" alt="Heritage Club 9" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-10.jpeg" alt="Heritage Club 10" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-11.jpeg" alt="Heritage Club 11" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="Club-card">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-12.jpeg" alt="Heritage Club 12" />
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Club;
